async function EditAction(mutationName, data, token) {
  try {
    await mutationName({ body: data, token });
  } catch (error) {
    console.log({ addError: error });
  }
}

export default EditAction;
